import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Message, MessagesResponse } from '../models/message.model';

export interface ListMessagesParams {
  onlyUnread?: boolean;
  page?: number;
  perPage?: number;
}

@Injectable({ providedIn: 'root' })
export class MessagesApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.baseUrl}/messages`;

  list(params: ListMessagesParams = {}): Observable<MessagesResponse> {
    let httpParams = new HttpParams();

    if (params.onlyUnread) {
      httpParams = httpParams.set('onlyUnread', 'true');
    }
    if (params.page) {
      httpParams = httpParams.set('page', params.page);
    }
    if (params.perPage) {
      httpParams = httpParams.set('perPage', params.perPage);
    }

    return this.http.get<MessagesResponse>(this.baseUrl, {
      params: httpParams,
    });
  }

  markAsRead(id: number): Observable<Message> {
    return this.http.patch<Message>(`${this.baseUrl}/${id}/read`, {});
  }
}
